module.exports = __webpack_public_path__ + "img/bannerText1.22d06bbd.png";